<script lang="ts">
  import { proficiencyLevelLabel } from '$lib/util';
  import { faCheck } from '@itdev-fortawesome/pro-solid-svg-icons/faCheck';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';

  // toggle button used to select skills when logging new skill entries.

  interface Props {
    skillId: number;
    skillName: string;
    proficiencyLevel?: number;
    checked: boolean;
    onchange: (val: boolean) => void;
  }

  let { skillId, skillName, proficiencyLevel, checked, onchange }: Props = $props();

  // note: skillId only used to determine order of skills presented to user
</script>

<button
  type="button"
  role="checkbox"
  data-skill-id={skillId}
  aria-checked={checked ? 'true' : 'false'}
  class="btn skill-checkbox"
  onclick={() => {
    onchange(!checked);
  }}
>
  <div class="label">
    <div>{skillName}</div>
    {#if proficiencyLevel !== undefined}
      <div class="subtitle">{proficiencyLevelLabel(proficiencyLevel)}</div>
    {/if}
  </div>
  <div class="fade-in" class:fade-in-visible={checked}>
    <FontAwesomeIcon icon={faCheck} />
  </div>
</button>

<style>
  .skill-checkbox {
    --bs-btn-hover-color: rgba(0, 0, 0, 0.6);
    --bs-btn-active-color: rgba(0, 0, 0, 0.6);
    --bs-btn-bg: var(--bs-secondary-bg);
    --bs-btn-hover-bg: rgba(var(--bs-secondary-bg-rgb), 0.75);
    display: flex;
    text-align: left;
    align-items: center;

    /*
      an attempt at a consistent button height even if a button is only using 1 line of text
      2x line-height + 2x padding-y + 2x border-width from .btn
    */
    min-height: calc(3em + 0.75rem + 2px);
  }

  .label {
    flex-grow: 1;
  }

  .subtitle {
    font-size: 0.825em;
    font-weight: 300;
    opacity: 0.85;
  }
</style>
